/**
 * "Step 1 of 2 · Kind / Details" — where you are in a short wizard.
 *
 * A progress indicator earns its space by answering "how much more is there", which
 * is why the count is spelled out rather than implied by two dots. Labels are one or
 * two words: they are a reminder of what each step asked, not its instructions.
 *
 * `aria-current="step"` is the whole accessibility contract here — an ordered list of
 * plain text, so nothing has to be announced as interactive. The steps are NOT
 * buttons: jumping to step 2 without a kind chosen has no meaning, and Back is the
 * one way backwards.
 */
export function Stepper({ steps, current }: { steps: string[]; current: number }) {
  return (
    <ol className="stepper" aria-label="Steps">
      {steps.map((label, i) => (
        <li
          key={label}
          className={`stepper__step${i === current ? ' stepper__step--on' : ''}${i < current ? ' stepper__step--done' : ''}`}
          aria-current={i === current ? 'step' : undefined}
        >
          <span className="step__mark">{i + 1}</span>
          <span className="stepper__label">
            {i === current && (
              <span className="stepper__of">
                Step {i + 1} of {steps.length} ·{' '}
              </span>
            )}
            {label}
          </span>
        </li>
      ))}
    </ol>
  );
}
